export const highlightRanges = (range, tagName = 'mark', attributes = {}) => {
  if (range.collapsed) return

  const nodes = textNodesInRange(range)

  const highlightElements = []
  for (const nodeIdx in nodes) {
    const highlightElement = wrapNodeInHighlight(nodes[nodeIdx], tagName, attributes)
    highlightElements.push(highlightElement)
  }
}

export const textNodesInRange = (range) => {
  if (range.startContainer.nodeType === Node.TEXT_NODE && range.startOffset > 0) {
    const endOffset = range.endOffset
    const createdNode = range.startContainer.splitText(range.startOffset)
    if (range.endContainer === range.startContainer) {
      range.setEnd(createdNode, endOffset - range.startOffset)
    }
    range.setStart(createdNode, 0)
  }
  if (
    range.endContainer.nodeType === Node.TEXT_NODE &&
    range.endOffset < range.endContainer.length
  ) {
    range.endContainer.splitText(range.endOffset)
  }

  const walker = range.startContainer.ownerDocument.createTreeWalker(
    range.commonAncestorContainer,
    NodeFilter.SHOW_TEXT,
    (node) => (range.intersectsNode(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT)
  )
  walker.currentNode = range.startContainer

  const nodes = []
  if (walker.currentNode.nodeType === Node.TEXT_NODE) nodes.push(walker.currentNode)
  while (walker.nextNode() && range.comparePoint(walker.currentNode, 0) !== 1)
    nodes.push(walker.currentNode)
  return nodes
}

export const getXpathParameters = (xpath) => {
  const startOffset = xpath.startOffset
  const endOffset = xpath.endOffset
  let start = xpath.start

  start = start.replace(/\(|\)/g, '')
  let end = xpath.end
  end = end.replace(/\(|\)/g, '')
  return { startOffset, endOffset, start, end }
}

export const wrapNodeInHighlight = (node, tagName, attributes) => {
  const highlightElement = node.ownerDocument.createElement(tagName)
  Object.keys(attributes).forEach((key) => {
    highlightElement.setAttribute(key, attributes[key])
  })
  const tempRange = node.ownerDocument.createRange()
  tempRange.selectNode(node)
  tempRange.surroundContents(highlightElement)
  return highlightElement
}

export const windowGetSelection = () => {
  //  if (window.getSelection) {
  return window.getSelection()
  // }

  // return null
}

export const positionToolTip = (selection) => {
  const scrollPosition =
    window.pageYOffset !== undefined
      ? window.pageYOffset
      : (document.documentElement || document.body).scrollTop
  let selectionRange = null
  if (selection instanceof HTMLElement) {
    selectionRange = selection?.getBoundingClientRect()
  } else {
    selectionRange = selection.getRangeAt(0)?.getBoundingClientRect()
  }

  const selectionRangeTop = selectionRange.top
    ? selectionRange.top
    : selectionRange.height < 0
    ? selectionRange.height + selectionRange.y
    : selectionRange.y

  const selectionRangeLeft = selectionRange.left
    ? selectionRange.left
    : selectionRange.width < 0
    ? selectionRange.x + selectionRange.width
    : selectionRange.width

  const selectionRangeRight = selectionRange.right
    ? selectionRange.right
    : selectionRange.width < 0
    ? selectionRange.x
    : selectionRange.x + selectionRange.width

  const top = selectionRangeTop + scrollPosition + selectionRange.height + 12
  const left = (selectionRangeLeft + selectionRangeRight) / 2 - 150

  return { top, left }
}
